import Log from './Log';

export default Log
export { Log as Base }
